import React, {
  useState, useEffect, useCallback,
} from 'react';
import { ThemeProvider } from 'styled-components';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { lightTheme, darkTheme } from './theme';
import Routes from './routes';
import { ParentNav, AppWrapper } from './components';
import { AppStateProvider, NotificationProvider } from './providers';
import { CcsV2FeatureAnnouncement } from './components/v2';
import './styles/toaster.css';

function App() {
  const [brandId, setBrandId] = useState('');
  const [userId, setUserId] = useState(null);
  const [isAuthed, setIsAuthed] = useState(false);
  const [themeMode, setThemeMode] = useState('');

  const setTheme = useCallback(async (mode) => {
    setThemeMode(mode);
    localStorage.setItem('theme', mode);
  }, []);

  // TODO: Move this out to a custom hook
  useEffect(() => {
    function axiosErrorInterceptor(error) {
      // should we only set is authed to false on 401?
      if (
        (error.response && (error.response.status === 401 || error.response.status === 403))
        && (error.config.url.indexOf('ccs/verify') > -1 || error.config.url.indexOf('/verify-bearer') > -1 || error.config.url.indexOf('/login') > -1)
      ) {
        setIsAuthed(false);
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }

    function axiosResponseInterceptor(response) {
      return response;
    }

    const interceptor = axios.interceptors.response.use(
      axiosResponseInterceptor,
      axiosErrorInterceptor,
    );

    const storedTheme = localStorage.getItem('theme');
    if (storedTheme && (storedTheme === 'light' || storedTheme === 'dark')) {
      // do not overwrite if we already have a value from network call
      setThemeMode((prev) => (prev || storedTheme));
    }

    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, []); // eslint-disable-line

  return (
    <ThemeProvider theme={themeMode === 'light' ? lightTheme : darkTheme}>
      <NotificationProvider
        toast={toast}
        themeMode={themeMode}
      >
        <AppStateProvider
          accountId={brandId}
          themeMode={themeMode}
          isAuthed={isAuthed}
          setTheme={setTheme}
          setAccountId={setBrandId}
        >
          <AppWrapper>
            <ParentNav />
            <Routes
              brandId={brandId}
              userId={userId}
              isAuthed={isAuthed}
              setUserId={setUserId}
              setIsAuthed={setIsAuthed}
              themeMode={themeMode}
            />
            <CcsV2FeatureAnnouncement />
            <ToastContainer limit={3} />
          </AppWrapper>
        </AppStateProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
